/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CategoryCountRequest {
    getFixupPrototypeFunction() { return CategoryCountRequest.fixupPrototype; }

    static newInstance(model: Partial<CategoryCountRequest>): CategoryCountRequest {
        let obj = Object.assign(new CategoryCountRequest(), model);
        CategoryCountRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CategoryCountRequest>): CategoryCountRequest {
        if (!model) return null;
        return CategoryCountRequest.newInstance(<CategoryCountRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CategoryCountRequest) {
        if (!obj) return;

        models.CategoryCountRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CategoryCountRequest): boolean {
        Object.setPrototypeOf(obj, CategoryCountRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.CountDetailsDataModel.fixupPrototype(this.filters);
        }
    }

    /**
     * Category/Resource based count for the cloud
     */
    identifier: models.InventorySelector;

    /**
     * Resource filters detail
     */
    filters: models.CountDetailsDataModel;

}
